import React, { useContext } from 'react';
import { Col, Empty, Row, Typography } from 'antd';

import AccountPlanContext from '@totem/components/accountPlan/AccountPlanContext';
import PlanCard from '@totem/components/accountPlan/PlanCard';

const Bullets = ({ items }: { items: string[] }) =>
  items.length === 0 ? (
    <Typography.Text type="secondary">—</Typography.Text>
  ) : (
    <ul style={{ paddingLeft: 18, margin: 0 }}>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );

const StrategyCard = () => {
  const { data, openEditor } = useContext(AccountPlanContext);
  if (!data) {
    return null;
  }
  const { strategy } = data.plan;
  const isEmpty =
    !strategy.goal &&
    !strategy.competitive &&
    strategy.risks.length === 0 &&
    strategy.priorities.length === 0;

  return (
    <PlanCard
      variant="manual"
      onEdit={() => openEditor({ section: 'strategy' })}
      title="Account Strategy & Goals"
    >
      {isEmpty ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No strategy yet — click “Maintained by AM” to add one."
        />
      ) : (
        <Row gutter={[16, 12]}>
          <Col span={24}>
            <Typography.Text type="secondary">
              Where we want this account in 12 months
            </Typography.Text>
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              {strategy.goal || '—'}
            </Typography.Paragraph>
          </Col>
          <Col xs={24} lg={12}>
            <Typography.Text type="secondary">
              Key risks / watch-outs
            </Typography.Text>
            <Bullets items={strategy.risks} />
          </Col>
          <Col xs={24} lg={12}>
            <Typography.Text type="secondary">
              Strategic priorities this quarter
            </Typography.Text>
            <Bullets items={strategy.priorities} />
          </Col>
          <Col span={24}>
            <Typography.Text type="secondary">
              Competitive landscape
            </Typography.Text>
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              {strategy.competitive || '—'}
            </Typography.Paragraph>
          </Col>
        </Row>
      )}
    </PlanCard>
  );
};

export default StrategyCard;
